"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleSettingWidget = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var Button_1 = require("../../Button");
var LoadingSpinner_1 = require("../../LoadingSpinner");
var SettingWidget_1 = require("../SettingWidget");
var Header_1 = require("../Header");
var Footer_1 = require("../Footer");
var Separator_1 = require("../Separator");
var Title_1 = require("../Title");
var FooterButtons_1 = require("../FooterButtons");
var Hyperlink_1 = require("../../Hyperlink");
/**
 * This widget toggles one setting on/off.
 *
 * @internal
 */
exports.SimpleSettingWidget = function (props) {
    var title = props.title, currentSettingStatus = props.currentSettingStatus, titleTooltip = props.titleTooltip, helpLinkText = props.helpLinkText, helpLinkUrl = props.helpLinkUrl, actionButtonText = props.actionButtonText, isLoading = props.isLoading, onSubmit = props.onSubmit, onHelpLinkClick = props.onHelpLinkClick;
    return (react_1.default.createElement(SettingWidget_1.SettingWidget, null,
        react_1.default.createElement(Header_1.Header, null,
            react_1.default.createElement(Title_1.Title, { title: title, tooltip: titleTooltip }),
            isLoading ? (react_1.default.createElement(LoadingSpinner_1.LoadingSpinner, { className: "small gd-loading-equalizer-spinner" })) : (react_1.default.createElement("span", { className: "gd-setting-widget-status-pill" }, currentSettingStatus))),
        react_1.default.createElement(Separator_1.Separator, null),
        react_1.default.createElement(Footer_1.Footer, null,
            helpLinkText && helpLinkUrl ? (react_1.default.createElement(Hyperlink_1.Hyperlink, { text: helpLinkText, href: helpLinkUrl, iconClass: "gd-icon-circle-question", onClick: onHelpLinkClick })) : null,
            !isLoading ? (react_1.default.createElement(FooterButtons_1.FooterButtons, null,
                react_1.default.createElement(Button_1.Button, { className: "gd-button-action", onClick: onSubmit, disabled: isLoading, value: actionButtonText }))) : null)));
};
//# sourceMappingURL=SimpleSettingWidget.js.map